import { css } from 'emotion';

export default {
    container: css`
        display: flex;
        justify-content: center;
    `,
    contentContainer: css`
        display: flex;
        flex-direction: column;
        width: 50vw;
        min-width: 350px;
        padding-bottom: 50px;
    `,
    formGroup: css`
        margin-bottom: 15px;
    `,
    submitButtonContainer: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    `
};
